import React, { useCallback, useContext, useState } from 'react';
import { Outlet, useMatch } from 'react-router-dom';

import { Loading } from '../../common/components/Loading';
import { AuthContext } from '../login/AuthWrapper';
import { ReferralCountProvider } from '../referral-action-required/ReferralCountContext';
import AppHeader from './header/AppHeader';
import { ISnacksProps } from './interfaces/ISnacksProps';
import { NoraSnackbarView } from './NoraSnackbarView';
import { SnackbarContext } from './SnackbarContext';

export const Layout = () => {
  const [openSnacks, setOpenSnacks] = useState<ISnacksProps[]>([]);
  const auth = useContext(AuthContext);

  const workbenchMatch = useMatch('/workbench');
  const overviewMatch = useMatch('/workbench/overview');
  const qaMatch = useMatch('/workbench/qa');
  const controlPanelMatch = useMatch('/workbench/controlpanel');
  const referralsActionRequiredMatch = useMatch(
    '/workbench/referrals/action-required',
  );
  const rbacManagerMatch = useMatch('/workbench/rbac');

  const isHomePath = Boolean(
    workbenchMatch ||
      overviewMatch ||
      qaMatch ||
      controlPanelMatch ||
      referralsActionRequiredMatch ||
      rbacManagerMatch,
  );

  const openSnack = useCallback((newSnack: ISnacksProps) => {
    setOpenSnacks(prev => [...prev, newSnack]);
  }, []);

  if (!auth.loggedIn) {
    return <Loading fullscreen={true} />;
  }

  return (
    <SnackbarContext.Provider
      value={{ openSnacks, setSnacks: setOpenSnacks, openSnack }}
    >
      <ReferralCountProvider>
        <AppHeader isBackButton={!isHomePath} />
        <Outlet />
        <NoraSnackbarView />
      </ReferralCountProvider>
    </SnackbarContext.Provider>
  );
};

export default Layout;
